import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { BuySell } from '../components/BuySell';
import { Valuation } from '../components/Valuation';
import { FeaturedProperties } from '../components/FeaturedProperties';
import { Communities } from '../components/Communities';
import { MarketData } from '../components/MarketData';
import { Team } from '../components/Team';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen flex flex-col" data-id="element-209">
      <Header data-id="element-210" />
      <main className="flex-grow" data-id="element-211">
        <Hero data-id="element-212" />
        <BuySell data-id="element-213" />
        <Valuation data-id="element-214" />
        <FeaturedProperties data-id="element-215" />
        <Communities data-id="element-216" />
        <MarketData data-id="element-217" />
        <Team data-id="element-218" />
        <Testimonials data-id="element-219" />
        <FinalCTA data-id="element-220" />
      </main>
      <Footer data-id="element-221" />
    </div>;
}